import { Linkable } from '@/components/blocks/Linkable';
import {
	productRatingsSx,
	ratingCardSx,
} from '@/components/blocks/PLPProductCard/styles/productRatings';
import { RatingCard } from '@/components/blocks/RatingCard';
import { TYPES } from '@/data/constants/product';
import { ProductType } from '@/data/types/Product';
import { getHref_Product } from '@/utils/getHref_Product';
import { productIsA } from '@/utils/productIsA';
import { Box } from '@mui/material';
import { memo } from 'react';

export const ProductRatings = memo(
	({
		product,
		productHref,
		onClick,
		isProductList,
	}: {
		productHref: ReturnType<typeof getHref_Product>;
		product: ProductType;
		onClick?: () => void;
		isProductList?: boolean;
	}) => {
		const isBundle = productIsA(product, TYPES.bundle);

		if (isBundle) {
			return <Box sx={productRatingsSx(isProductList)} />;
		}

		return (
			<Linkable
				sx={productRatingsSx(isProductList)}
				href={productHref}
				color="textPrimary"
				onClick={onClick}
			>
				<RatingCard sx={ratingCardSx} ratings={product.ratings} />
			</Linkable>
		);
	}
);
